import React from "react"
import { Helmet } from "react-helmet"

import Layout from "../../components/layout/layout"
import Button from "../../components/button/button"
import PrimaryBanner from "../../components/banner/primaryBanner"
import TrainingPartnersCard from "../../components/card/TrainingPartnersCard"
import LXPCard from "../../components/card/LXPCard"

import "../../styles/_solution.scss"

import teamsplus1 from "../../images/teamsplus/teamsplus-1.svg"
import teamsplus2 from "../../images/teamsplus/teamsplus-2.svg"
import teamsplus3 from "../../images/teamsplus/teamsplus-3.svg"
import teamsplus4 from "../../images/teamsplus/teamsplus-4.svg"

import teamsPlusLogo from "../../images/teamsplus-logo.svg"
import CEOWyn from "../../images/wyn.svg"
import mumaLogo from "../../images/muma-logo.svg"
import starIcon from "../../images/icon/star.svg"
import lockIcon from "../../images/icon/lock.svg"
import gearIcon from "../../images/icon/gear-person.svg"
import quoteIcon from "../../images/icon/quote.svg"
import newWindowIcon from "../../images/icon/new-window.svg"
import newWindowIconDark from "../../images/icon/new-window-dark.svg"
import CustomLink from "../../components/naviGroup/customLink"

const Brief: React.FC = () => {
  return (
    <div className="brief-container layout-container">
      <div className="brief-left">
        <h1>
          <span>Enhance people </span>
          <span>capability</span>
        </h1>
        <div className="solution-with-container">
          <span className="solution-with-label">with</span>
          <img
            src={teamsPlusLogo}
            alt="TeamsPlus logo"
            style={{ height: "40px" }}
          />
        </div>
        <p className="p-lg" style={{ marginBottom: "35px" }}>
          Drive continuous learning, compliance and capability by unifying your
          people with the skills, tools and feedback from our Learning
          Experience Platform (LXP).
        </p>
        <CustomLink to="http://www.teamsplus.co.nz">
          <Button isResponsive={true}>
            Learn more at teamsplus.co.nz
            <img
              alt="go to teams plus"
              src={newWindowIcon}
              style={{ width: "20px", marginLeft: "15px" }}
            />
          </Button>
        </CustomLink>
      </div>
      <div className="brief-right">
        <div className="brief-right-background teamsplus-right"></div>
        <div className="brief-right-image teamsplus-right"></div>
      </div>
    </div>
  )
}

const IconSection: React.FC = () => {
  return (
    <div className="solution-icons-section">
      <div className="icon-group layout-container">
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={gearIcon} alt="personalised learning" />
          </div>
          <div className="icon-content">
            <p className="p-re">Personalised</p>
            <p className="p-re">learning</p>
          </div>
        </div>
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={starIcon} alt="great user experiences" />
          </div>
          <div className="icon-content">
            <p className="p-re">Great user</p>
            <p className="p-re">experiences</p>
          </div>
        </div>
        <div className="icon-wrapper">
          <div className="icon-container">
            <img src={lockIcon} alt="Highly Trusted" />
          </div>
          <div className="icon-content">
            <p className="p-re">Highly</p>
            <p className="p-re">trusted</p>
          </div>
        </div>
      </div>
    </div>
  )
}

const CardSection: React.FC = () => {
  return (
    <div className="solution-group-wrapper">
      <div className="layout-container">
        <div className="solution-wrapper">
          <div className="solution-content">
            <h4 style={{ marginBottom: "10px" }}>
              Complete continuous learning solution for teams
            </h4>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              One system to onboard, protect, manage, develop and grow your team
            </p>
          </div>
          <img
            src={teamsplus1}
            className="solution-image"
            alt="Learning solutions"
          />
        </div>
        <div className="solution-wrapper">
          <img src={teamsplus2} className="solution-image" alt="templates" />
          <div className="learning-content">
            <h4 style={{ marginBottom: "10px" }}>
              Built-in templates and/or custom content
            </h4>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Create unique training with dynamic video and editing capabilities
              to suit your business from out-of-the-box templates or your own
              courses.
            </p>
          </div>
        </div>
        <div className="solution-wrapper">
          <div className="solution-content">
            <h4 style={{ marginBottom: "10px" }}>
              Dynamic, personalised learning pathways
            </h4>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Arm your team with the personalised, targeted skills they need.
              Set deadlines and assign refresher courses to keep your team up to
              date, and create your own courses to suit your unique
              requirements.
            </p>
          </div>
          <img src={teamsplus3} className="solution-image" alt="Pathways" />
        </div>
        <div className="solution-wrapper">
          <img
            src={teamsplus4}
            className="solution-image"
            alt="Risk management"
          />
          <div className="learning-content">
            <h4 style={{ marginBottom: "10px" }}>
              Risk management & compliance
            </h4>
            <p className="p-lg" style={{ maxWidth: "500px" }}>
              Targeted training to start lowering your risk. Drill down to teams
              and individuals to check on your team's progress.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

const ReviewSection: React.FC = () => {
  const ReviewCard: React.FC = () => {
    return (
      <div className="review-card-container">
        <div className="review-card-quote">
          <img src={quoteIcon} alt="quote icon" />
        </div>
        <p className="p-lg">
          Using TeamsPlus I was able to create a training programme for our
          entire company in only a few hours.
        </p>
        <div className="review-owner-wrapper">
          <div className="review-owner-container">
            <img src={CEOWyn} className="review-owner-image" alt="CEO Wyn" />
            <div>
              <div style={{ fontWeight: "700" }}>Wyn Osborne</div>
              <div>CEO</div>
            </div>
          </div>
          <img src={mumaLogo} alt="Muma logo" />
        </div>
      </div>
    )
  }

  return (
    <PrimaryBanner>
      <div className="layout-container">
        <div className="review-section-container">
          <ReviewCard></ReviewCard>
          <h3 className="review-heading">Choose the better way of learning</h3>
          <CustomLink to="https://www.teamsplus.co.nz">
            <Button isSecondary={true} isSmall={true}>
              Learn more at teamsplus.co.nz
              <img
                alt="go to teams plus"
                src={newWindowIconDark}
                style={{ width: "20px", marginLeft: "15px" }}
              />
            </Button>
          </CustomLink>
        </div>
      </div>
    </PrimaryBanner>
  )
}

const OtherSolutionSection: React.FC = () => {
  return (
    <div className="layout-container other-solution-section-container">
      <h3>Explore other solutions</h3>
      <div className="other-solution-card-group">
        <TrainingPartnersCard className="other-solution-card" />
        <LXPCard className="other-solution-card" />
      </div>
    </div>
  )
}

const TeamsPlus: React.FC = () => {
  return (
    <Layout>
      <Helmet>
        <title>Dacreed | Solution TeamsPlus</title>
        <meta
          name="description"
          content="Drive continuous learning, compliance, and capability for people and Teams"
        />
      </Helmet>
      <Brief />
      <IconSection />
      <CardSection />
      <ReviewSection />
      <OtherSolutionSection />
    </Layout>
  )
}

export default TeamsPlus
